import createCompanySlice from "./company";
import { CompanySlice } from "./company.types";

export type { CompanySlice };
export default createCompanySlice;
